document.addEventListener("DOMContentLoaded", () => {
	const section = document.querySelector(".quiz-two-months");
	if (!section) return;

	const quizWrap = section.querySelector(".quiz-content__wrapper");
	if (!quizWrap) return;

	function clickCurrentNext() {
		const currentFs = quizWrap.querySelector("fieldset.cf7mls_current_fs");
		if (!currentFs) return;

		const btn =
			currentFs.querySelector(".cf7mls_next") ??
			currentFs.nextElementSibling?.querySelector(".cf7mls_next") ??
			currentFs.parentElement?.querySelector(".cf7mls-btns .cf7mls_next");

		if (btn) {
			btn.click();
			return;
		}

		// Fallback: якщо плагін не додав кнопку для першого кроку — переключаємо вручну
		const allFs = Array.from(
			quizWrap.querySelectorAll("fieldset.fieldset-cf7mls"),
		);
		const idx = allFs.indexOf(currentFs);
		if (idx >= 0 && idx < allFs.length - 1) {
			currentFs.classList.remove("cf7mls_current_fs");
			allFs[idx + 1].classList.add("cf7mls_current_fs");
		}
	}

	quizWrap.addEventListener("click", (e) => {
		if (e.target.closest(".quiz-two-months__start")) {
			clickCurrentNext();
		}
	});

	function showGoalResult() {
		const resultStep = quizWrap.querySelector("[data-child-goal-results]");
		if (!resultStep) return;

		const fieldset = resultStep.closest("fieldset");
		if (!fieldset?.classList.contains("cf7mls_current_fs")) return;

		const radios = Array.from(
			quizWrap.querySelectorAll('input[name="child_goal"]'),
		);
		const selectedIndex = radios.findIndex((r) => r.checked);
		if (selectedIndex < 0) return;

		resultStep
			.querySelectorAll("[data-child-goal-result]")
			.forEach((el) => {
				el.hidden =
					parseInt(el.dataset.childGoalResult, 10) !== selectedIndex;
			});
	}

	let formSent = false;

	function checkFormModal() {
		if (formSent) return;
		const currentFs = quizWrap.querySelector("fieldset.cf7mls_current_fs");
		const isForm = !!currentFs?.querySelector(".quiz-content__step.four");
		section.classList.toggle("is-modal-open", isForm);
	}

	document.addEventListener(
		"wpcf7mailsent",
		() => {
			formSent = true;
			const thanks = section.querySelector(".quiz-thanks");
			if (thanks) {
				thanks.hidden = false;
				thanks.removeAttribute("aria-hidden");
			}
			section.classList.add("is-modal-open");
		},
		true,
	);

	const observer = new MutationObserver(() => {
		showGoalResult();
		checkFormModal();
	});
	observer.observe(quizWrap, {
		subtree: true,
		attributes: true,
		attributeFilter: ["class"],
	});
});
